"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterWithDropdownList = FilterWithDropdownList;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _DropdownList = require("./DropdownList");
var _Dropdown = require("../Dropdown");
var _DropdownFilterButton = require("../DropdownFilterButton");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Визуальный компонент рендерит фильтр с открывающимся дропдауном - списком
 * Переиспользуемый для строки фильтров на десктопе. Не для мобайла
 * */

function FilterWithDropdownList(props) {
  const {
    value,
    placeholder,
    onValueChange,
    className,
    values,
    isLastFilter,
    isFirstFilter,
    testId,
    errorMessage
  } = props;

  /**
   * Здесь вычисляется лейбл, который будет отрисован на закрытом дропдауне (т.е на кнопке)
   * Если есть активный элемент, то лейбл возьмется из него. Иначе - будет дефолтный плейсхолдер
   *  */
  const label = React.useMemo(() => {
    if (value == null) {
      return placeholder;
    }
    const activeItem = values.find(v => v.value === value);
    return activeItem ? activeItem.label : placeholder;
  }, [placeholder, value, values]);
  return /*#__PURE__*/React.createElement(_Dropdown.Dropdown, {
    errorMessage: errorMessage,
    testId: `${testId}_dropdown`,
    classes: {
      root: className,
      dropdown: styles['dropdown']
    },
    master: _ref => {
      let {
        isOpen,
        handleToggle
      } = _ref;
      return /*#__PURE__*/React.createElement(_DropdownFilterButton.DropdownFilterButton, {
        label: label,
        handleToggle: handleToggle,
        isEmpty: value == null,
        isActive: isOpen,
        isFirstFilter: isFirstFilter,
        isLastFilter: isLastFilter,
        testId: testId
      });
    },
    render: _ref2 => {
      let {
        handleClose
      } = _ref2;
      return /*#__PURE__*/React.createElement(_DropdownList.DropdownList, {
        value: value,
        values: values,
        onValueChange: val => {
          onValueChange(val);
          handleClose();
        }
      });
    }
  });
}